// src/app/core/services/api.service.ts
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';

import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  // --- GET ---

  get<T>(
    path: string,
    options?: {
      headers?: HttpHeaders | { [header: string]: string | string[] };
      params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string> };
    }
  ): Observable<T>;

  get<T>(
    path: string,
    options: {
      observe: 'response';
      headers?: HttpHeaders | { [header: string]: string | string[] };
      params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string> };
    }
  ): Observable<HttpResponse<T>>;

  get(
    path: string,
    options: any = {}
  ): Observable<any> {
    return this.http.get(`${this.baseUrl}${path}`, options);
  }

  // --- POST ---

  post<T>(
    path: string,
    body: any,
    options?: {
      headers?: HttpHeaders | { [header: string]: string | string[] };
      params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string> };
    }
  ): Observable<T>;

  post<T>(
    path: string,
    body: any,
    options: {
      observe: 'response';
      headers?: HttpHeaders | { [header: string]: string | string[] };
      params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string> };
    }
  ): Observable<HttpResponse<T>>;

  post(
    path: string,
    body: any,
    options: any = {}
  ): Observable<any> {
    console.log("URL - " + this.baseUrl)
    return this.http.post(`${this.baseUrl}${path}`, body, options);
  }

  // --- PUT ---

  put<T>(
    path: string,
    body: any,
    options?: {
      headers?: HttpHeaders | { [header: string]: string | string[] };
      params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string> };
    }
  ): Observable<T>;

  put<T>(
    path: string,
    body: any,
    options: {
      observe: 'response';
      headers?: HttpHeaders | { [header: string]: string | string[] };
      params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string> };
    }
  ): Observable<HttpResponse<T>>;

  put(
    path: string,
    body: any,
    options: any = {}
  ): Observable<any> {
    return this.http.put(`${this.baseUrl}${path}`, body, options);
  }

  // --- DELETE ---

  delete<T>(
    path: string,
    options?: {
      headers?: HttpHeaders | { [header: string]: string | string[] };
      params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string> };
    }
  ): Observable<T>;

  delete<T>(
    path: string,
    options: {
      observe: 'response';
      headers?: HttpHeaders | { [header: string]: string | string[] };
      params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string> };
    }
  ): Observable<HttpResponse<T>>;

  delete(
    path: string,
    options: any = {}
  ): Observable<any> {
    return this.http.delete(`${this.baseUrl}${path}`, options);
  }
}
